import React from 'react';
import { getDaysUntil, getEquipmentStatus, getStatusColor, getStatusLabel } from '../utils/helpers';

/**
 * Read-only preview: same rules as the equipment list "État" column.
 * Based only on nextMaintenanceDate (not a separate DB field on the form).
 */
const EquipmentCalculatedStatus = ({ nextMaintenanceDate }) => {
  if (!nextMaintenanceDate) {
    return (
      <p className="text-sm text-gray-500 col-span-2">
        État dans les listes : <span className="font-medium text-gray-700">Conforme</span> (aucune prochaine date renseignée)
      </p>
    );
  }

  const status = getEquipmentStatus({ nextMaintenanceDate });
  const days = getDaysUntil(nextMaintenanceDate);
  let detail = '';
  if (days !== null) {
    if (days < 0) detail = ` (${Math.abs(days)} jour(s) en retard)`;
    else if (days === 0) detail = ' (échéance aujourd\'hui)';
    else detail = ` (${days} jour(s) restants)`;
  }

  return (
    <p className="text-sm text-gray-600 col-span-2">
      État affiché dans les listes :{' '}
      <span className={`inline-block px-2 py-0.5 rounded text-xs font-semibold ${getStatusColor(status)}`}>
        {getStatusLabel(status)}
      </span>
      {detail}
      <span className="block text-xs text-gray-400 mt-1">
        Règle : plus de 30 j → Conforme · 8–30 j → Expire bientôt · 0–7 j → Maintenance requise · date passée → Expiré
      </span>
    </p>
  );
};

export default EquipmentCalculatedStatus;
